import { Typography, styled } from '@mui/material';
import PropTypes from 'prop-types';

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontWeight: '400',
}));

const Title = ({ subTitle = false, text, ...restProps }) => {
  if (subTitle) {
    return (
      <StyledSubtitle variant="h4" {...restProps}>
        {text}
      </StyledSubtitle>
    );
  } else {
    return (
      <StyledTitle variant="h2" {...restProps}>
        {text}
      </StyledTitle>
    );
  }
};

Title.propTypes = {
  subTitle: PropTypes.bool,
  text: PropTypes.string,
};

export default Title;
